/** Supported UI languages — labels shown in native script */
export const SUPPORTED_LANGUAGES = [
  { code: 'en-IN', label: 'English (India)', native: 'English (India)' },
  { code: 'hi', label: 'Hindi', native: 'हिंदी' },
  { code: 'ta', label: 'Tamil', native: 'தமிழ்' },
  { code: 'te', label: 'Telugu', native: 'తెలుగు' },
  { code: 'kn', label: 'Kannada', native: 'ಕನ್ನಡ' },
  { code: 'ml', label: 'Malayalam', native: 'മലയാളം' },
  { code: 'gu', label: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'mr', label: 'Marathi', native: 'मराठी' },
  { code: 'pa', label: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
];

export const DEFAULT_LANGUAGE = 'en-IN';
export const STORAGE_KEY = 'dq_ui_language';

/** Languages that are both configured and loaded in i18n resources */
export function getAvailableLanguages(i18n) {
  const loaded = new Set(Object.keys(i18n?.options?.resources ?? {}));
  return SUPPORTED_LANGUAGES.filter((lang) => loaded.has(lang.code));
}
